import { render, staticRenderFns } from "./saleOrderAssign.vue?vue&type=template&id=55824d2d&scoped=true&"
import script from "./saleOrderAssign.vue?vue&type=script&lang=js&"
export * from "./saleOrderAssign.vue?vue&type=script&lang=js&"
import style0 from "./saleOrderAssign.vue?vue&type=style&index=0&id=55824d2d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55824d2d",
  null
  
)

component.options.__file = "saleOrderAssign.vue"
export default component.exports